import { useCallback } from "react";
import { useAppDispatch } from "../app/hooks";
import { ApiBase } from "../api/api-base";
import { apiActions } from "../slices/api-slice";
import { ResponseBase } from "../api/response-base";
import { Awaited } from "../utilities/utility.type";
import { CustomError } from '../models/custom-error';
import { ApiGetProducts } from "../api/sift/back/api-products";

type ResponseType<T extends ApiBase> = Exclude<
  Exclude<
    Awaited<
      ReturnType<T['do']>>, CustomError
    >['body']['data'],
    undefined
>;

export const useApiActions = () => {
  const dispatch = useAppDispatch();
  const asyncApiRun = useCallback(<T extends ApiBase>(
    module: T,
    callback?: {
      /** onErrorがある場合はonErrorを ない場合はrejectを返す */
      onError?: (e: any) => void,
    },
    options?: {
      apiName?: string,
      ignoreSystemError?: boolean,
      ignoreTimeout?: boolean,
    },
  ) => {
    return new Promise<ResponseType<T>>((resolve, reject) => {
      dispatch(apiActions.run(
        module,
        {
          onSuccess: (res: ResponseBase<any>) => {
            // レスポンスがjsonの時意外はエラーを返す
            if (
              !(
                typeof res === 'object'
                && res !== null
                && Object.getPrototypeOf(res) === Object.prototype
              )
            ) {
              throw new Error('レスポンスの形式がJSONではありません');
            }
            if (!res.body.data || Number(res.error.errorCode) !== 200) {
              console.error(`failed api [${module.method}]:${module.path}`);
              (callback?.onError ?? reject)?.(res);
            } else {
              if (res instanceof CustomError) {
                reject(res);
              } else {
                resolve(res.body.data);
              }
            }
          },
          onError: (error) => {
            console.error(`failed api [${module.method}]:${module.path}`);
            (callback?.onError ?? reject)?.(error);
          }
        },
        options,
      ))
  
    })
  }, [dispatch]);

  return {
    asyncApiRun,
  }
}
